import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule, ErrorHandler } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxSortableModule } from 'ngx-sortable';
// ag-grid
import { AgGridModule } from "ag-grid-angular";
// import {MatMenuModule} from '@angular/material/menu';
// application
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IstComponent } from './ist/ist.component';
import { EapComponent } from './eap/eap.component';
import { GrantsComponent } from './grants/grants.component';
import { UmComponent } from './um/um.component';
import { IstRegistrationsComponent } from './ist/ist-registrations/ist-registrations.component';
import { IstApplicationsComponent } from './ist/ist-applications/ist-applications.component';
import { IstMyApplicationsComponent } from './ist/ist-my-applications/ist-my-applications.component';
import { ClientGridComponent } from './common/client-grid/client-grid.component';
import { OperationsBarComponent, MyFilterPipe } from './common/operations-bar/operations-bar.component';
import { IstApplicationExtComponent } from './ist/ist-application-ext/ist-application-ext.component';
import { ExtHeaderComponent } from './common/ext-header/ext-header.component';
import { HeaderComponent } from './common/header/header.component';
import { IstGeneralInformationComponent } from './ist/ist-application-ext/ist-general-information/ist-general-information.component';
import { IstStudyTeamTeamComponent } from './ist/ist-application-ext/ist-study-team-team/ist-study-team-team.component';
import { MessageBoxComponent } from './common/message-box/message-box.component';
import { AssignDialogComponent } from './common/assign-dialog/assign-dialog.component';
import { UmDepartmentComponent } from './um/um-department/um-department.component';
import { UmUserComponent } from './um/um-user/um-user.component';
import { UmRoleComponent } from './um/um-role/um-role.component';
import { UmOrganizationComponent } from './um/um-organization/um-organization.component';
import { AdministrationComponent } from './administration/administration.component';
import { PersonalizationComponent } from './personalization/personalization.component';
import { ChangeThemeComponent } from './personalization/change-theme/change-theme.component';
import { ChangePasswordComponent } from './personalization/change-password/change-password.component';
import { ViewProfileComponent } from './personalization/view-profile/view-profile.component';
import { LoginComponent } from './common/login/login.component';
import { AuthGuard } from './services/auth.guard';
import { HomeComponent } from './home/home.component';
import { UmUserViewModalComponent } from './um/um-user/um-user-view-modal/um-user-view-modal.component';
import { UmDepartmentViewModalComponent } from './um/um-department/um-department-view-modal/um-department-view-modal.component';
import { IstMilestonesComponent } from './ist/ist-application-ext/ist-milestones/ist-milestones.component';
import { IstStudyTeamOrganizationComponent } from './ist/ist-application-ext/ist-study-team-organization/ist-study-team-organization.component';
import { UmOrganizationViewModalComponent } from './um/um-organization/um-organization-view-modal/um-organization-view-modal.component';
import { UmRoleViewModalComponent } from './um/um-role/um-role-view-modal/um-role-view-modal.component';
import { IstMilestonesViewModalComponent } from './ist/ist-application-ext/ist-milestones/ist-milestones-view-modal/ist-milestones-view-modal.component';
import { IstAmendmentsComponent } from './ist/ist-application-ext/ist-amendments/ist-amendments.component';
import { IstAmendmentsViewModalComponent } from './ist/ist-application-ext/ist-amendments/ist-amendments-view-modal/ist-amendments-view-modal.component';
import { IstSiteEvluationComponent } from './ist/ist-application-ext/ist-site-evaluation/ist-site-evluation.component';
import { IstSiteEvaluationViewModalComponent } from './ist/ist-application-ext/ist-site-evaluation/ist-site-evaluation-view-modal/ist-site-evaluation-view-modal.component';

import { IstStudyReportsComponent } from './ist/ist-application-ext/ist-study-reports/ist-study-reports.component';
import { IstStudyReportsViewModalComponent } from './ist/ist-application-ext/ist-study-reports/ist-study-reports-view-modal/ist-study-reports-view-modal.component';
import { IstActivitiesSeminarsComponent } from './ist/ist-application-ext/ist-activities-seminars/ist-activities-seminars.component';
import { IstActivitiesSeminarsViewModalComponent } from './ist/ist-application-ext/ist-activities-seminars/ist-activities-seminars-view-modal/ist-activities-seminars-view-modal.component';
import { IstPublicationsComponent } from './ist/ist-application-ext/ist-publications/ist-publications.component';
import { IstPublicationsViewModalComponent } from './ist/ist-application-ext/ist-publications/ist-publications-view-modal/ist-publications-view-modal.component';
import { AttachmentsComponent } from './common/attachments/attachments.component';
import { RfiComponent } from './common/rfi/rfi.component';
import { NotesComponent } from './common/notes/notes.component';
import { IstInstitutionalReviewBoardComponent } from './ist/ist-application-ext/ist-institutional-review-board/ist-institutional-review-board.component';
import { IstConceptProposalComponent } from './ist/ist-application-ext/ist-concept-proposal/ist-concept-proposal.component';
import { IstStudyTeamOrganizationViewModalComponent } from './ist/ist-application-ext/ist-study-team-organization/ist-study-team-organization-view-modal/ist-study-team-organization-view-modal.component';
import { IstStudyTeamTeamViewModalComponent } from './ist/ist-application-ext/ist-study-team-team/ist-study-team-team-view-modal/ist-study-team-team-view-modal.component';
import { RouteComponent } from './common/route/route.component';
import { NotesViewModalComponent } from './common/notes/notes-view-modal/notes-view-modal.component';
import { WithdrawComponent } from './common/withdraw/withdraw.component';
import { AttachmentsViewModalComponent } from './common/attachments/attachments-view-modal/attachments-view-modal.component';
import { RfiViewModalComponent } from './common/rfi/rfi-view-modal/rfi-view-modal.component';
import { ConfirmOtpComponent } from './common/withdraw/confirm-otp/confirm-otp.component';
import { IstSiteEvaluationUpdateStatusComponent } from './ist/ist-application-ext/ist-site-evaluation/ist-site-evaluation-update-status/ist-site-evaluation-update-status.component';
import { GrantsGeneralInformationComponent } from './grants/grants-application-ext/grants-general-information/grants-general-information.component';
import { GrantsGrantInformationComponent } from './grants/grants-application-ext/grants-grant-information/grants-grant-information.component';
import { IstRegistrationsViewModalComponent } from './ist/ist-registrations/ist-registrations-view-modal/ist-registrations-view-modal.component';
import { DeleteBoxComponent } from "./common/delete-box/delete-box.component";
import { UmOrganizationPasswordPolicyViewModalComponent } from './um/um-organization/um-organization-password-policy-view-modal/um-organization-password-policy-view-modal.component';
import { IstStudyTeamViewComponent } from './ist/ist-application-ext/ist-study-team-team/ist-study-team-view/ist-study-team-view.component';
import { GrantsLetterOfIntentComponent } from './grants/grants-application-ext/grants-letter-of-intent/grants-letter-of-intent.component';
import { GrantsUserInstructionsComponent } from './grants/grants-application-ext/grants-user-instructions/grants-user-instructions.component';
import { GrantsDeliveryFormatComponent } from './grants/grants-application-ext/grants-delivery-format/grants-delivery-format.component';
import { GrantsAudiencesComponent } from './grants/grants-application-ext/grants-audiences/grants-audiences.component';
import { GrantsBudgetComponent } from './grants/grants-application-ext/grants-budget/grants-budget.component';
import { GrantsAuthorizedSigneeAndPayeeComponent } from './grants/grants-application-ext/grants-authorized-signee-and-payee/grants-authorized-signee-and-payee.component';
import { GrantsOutcomeAssessmentComponent } from './grants/grants-application-ext/grants-outcome-assessment/grants-outcome-assessment.component';
import { GrantsReconciliationComponent } from './grants/grants-application-ext/grants-reconciliation/grants-reconciliation.component';
import { GrantsDocumentUploadComponent } from './grants/grants-application-ext/grants-document-upload/grants-document-upload.component';
import { GrantsRegistrationsComponent } from './grants/grants-registrations/grants-registrations.component';
import { GrantsMyApplicationsComponent } from './grants/grants-my-applications/grants-my-applications.component';
import { GrantsApplicationsComponent } from './grants/grants-applications/grants-applications.component';
import { GrantsRegistrationsViewModalComponent } from './grants/grants-registrations/grants-registrations-view-modal/grants-registrations-view-modal.component';
import { GrantsApplicationExtComponent } from './grants/grants-application-ext/grants-application-ext.component';
import { GrantsAuthorizedSigneeAndPayeeViewModalComponent } from './grants/grants-application-ext/grants-authorized-signee-and-payee/grants-authorized-signee-and-payee-view-modal/grants-authorized-signee-and-payee-view-modal.component';
import { GrantsOutcomeAssessmentViewModalComponent } from './grants/grants-application-ext/grants-outcome-assessment/grants-outcome-assessment-view-modal/grants-outcome-assessment-view-modal.component';
import { GrantsAudiencesViewModalComponent } from './grants/grants-application-ext/grants-audiences/grants-audiences-view-modal/grants-audiences-view-modal.component';
import { EapApplicationsComponent } from './eap/eap-applications/eap-applications.component';
import { EapMyApplicationsComponent } from './eap/eap-my-applications/eap-my-applications.component';
import { EapApplicationExtComponent } from './eap/eap-application-ext/eap-application-ext.component';
import { EapProgramInfoComponent } from './eap/eap-application-ext/eap-program-info/eap-program-info.component';
import { EapStudyTeamTeamComponent } from './eap/eap-application-ext/eap-study-team-team/eap-study-team-team.component';
import { EapStudyTeamOrganizationComponent } from './eap/eap-application-ext/eap-study-team-organization/eap-study-team-organization.component';
import { CorrespondenceComponent } from './common/correspondence/correspondence.component';
import { GrantsBudgetViewModalComponent } from './grants/grants-application-ext/grants-budget/grants-budget-view-modal/grants-budget-view-modal.component';
import { GrantsBudgetAllocateComponent } from './grants/grants-application-ext/grants-budget/grants-budget-allocate/grants-budget-allocate.component';
import { GrantsBudgetViewBudgetRequestComponent } from './grants/grants-application-ext/grants-budget/grants-budget-view-budget-request/grants-budget-view-budget-request.component';
import { GrantsBudgetRecordExpenditureComponent } from './grants/grants-application-ext/grants-reconciliation/grants-budget-record-expenditure/grants-budget-record-expenditure.component';
import { LookupsComponent } from './administration/lookups/lookups.component';
import { ProductComponent } from './administration/product/product.component';
import { ProgramComponent } from './administration/program/program.component';
import { CCodeComponent } from './administration/c-code/c-code.component';
import { NotificationStoreComponent } from './administration/notification-store/notification-store.component';
import { LdapConfigurationComponent } from './administration/ldap-configuration/ldap-configuration.component';
import { SamlSsoConfigurationComponent } from './administration/saml-sso-configuration/saml-sso-configuration.component';
import { ForgotPasswordComponent } from './common/forgot-password/forgot-password.component';
import { EapTypeComponent } from './administration/eap-type/eap-type.component';
import { LookupsModalEditComponent } from './administration/lookups/lookups-modal-edit/lookups-modal-edit.component';
import { LookupsAddMultipleComponent } from './administration/lookups/lookups-add-multiple/lookups-add-multiple.component';
import { EapTypeViewComponent } from './administration/eap-type/eap-type-view/eap-type-view.component';
import { ProductViewModalComponent } from './administration/product/product-view-modal/product-view-modal.component';
import { AddProductApprovalComponent } from './administration/product/add-product-approval/add-product-approval.component';
import { AvailableProductsComponent } from './administration/available-products/available-products.component';
import { ProgramViewModalComponent } from './administration/program/program-view-modal/program-view-modal.component';
import { SetFormatComponent } from './administration/c-code/set-format/set-format.component';
import { UmUserMapUserViewModalComponent } from './um/um-user/um-user-map-user-view-modal/um-user-map-user-view-modal.component';
import { GrantsRegistrationsComplianceComponent } from './grants/grants-registrations/grants-registrations-compliance/grants-registrations-compliance.component';
import { RequestTypeModalComponent } from './grants/grants-applications/request-type-modal/request-type-modal.component';
import { LetterOfIntentModalComponent } from './grants/grants-applications/letter-of-intent-modal/letter-of-intent-modal.component';
import { UserInstructionModalComponent } from './grants/grants-applications/user-instruction-modal/user-instruction-modal.component';
import { RfiAddModalComponent } from './common/rfi/rfi-add-modal/rfi-add-modal.component';
import { EditOthersRenderer, NoAddBtnPipe } from './common/client-grid/edit-others-operations.component';
import { DeleteOperationsRenderer } from './common/client-grid/delete-operations.component';
import { TextareaAddonComponent } from './common/textarea-addon/textarea-addon.component';
import { ComplainceStatementComponent } from './common/complaince-statement/complaince-statement.component';
import { IstAllRequestsComponent } from './ist/ist-application-ext/ist-all-requests/ist-all-requests.component';
import { AllRequestsViewModalComponent } from './ist/ist-application-ext/ist-all-requests/all-requests-view-modal/all-requests-view-modal.component';
import { LookupsSortOrderComponent } from './administration/lookups/lookups-sort-order/lookups-sort-order.component';
import { ReturnRetrivalModalComponent } from './ist/ist-application-ext/ist-all-requests/return-retrival-modal/return-retrival-modal.component';
import { FundRequestModalComponent } from './ist/ist-application-ext/ist-all-requests/fund-request-modal/fund-request-modal.component';
import { FundReturnRetrivalModalComponent } from './ist/ist-application-ext/ist-all-requests/fund-return-retrival-modal/fund-return-retrival-modal.component';
import { InstructionsComponent } from './administration/instructions/instructions.component';
import { InstructionsModalComponent } from './administration/instructions/instructions-modal/instructions-modal.component';
import { FaqComponent } from './administration/faq/faq.component';
import { FaqModalComponent } from './administration/faq/faq-modal/faq-modal.component';
import { FaqViewComponent } from './common/faq-view/faq-view.component';
import { DocumentTemplateComponent } from './common/document-template/document-template.component';
import { PolicyConfiguratorComponent } from './administration/policy-configurator/policy-configurator.component';
import { ScreenRepositoryComponent } from './administration/screen-repository/screen-repository.component';
import { ScreenRepositoryModalComponent } from './administration/screen-repository/screen-repository-modal/screen-repository-modal.component';
import { ConfigureControlsModalComponent } from './administration/screen-repository/configure-controls-modal/configure-controls-modal.component';
import { GrantsDocumentUploadSponsorshipComponent } from './grants/grants-application-ext/grants-document-upload-sponsorship/grants-document-upload-sponsorship.component';
import { GrantsGeneralInformationCharitableComponent } from './grants/grants-application-ext/grants-general-information-charitable/grants-general-information-charitable.component';
import { GrantsGeneralInformationSponsorshipComponent } from './grants/grants-application-ext/grants-general-information-sponsorship/grants-general-information-sponsorship.component';
import { RfpGrantsComponent } from './grants/grants-applications/rfp-grants/rfp-grants.component';
import { FileUploadComponent } from './common/file-upload/file-upload.component';
import { IstStudyTeamAddOrRoleComponent } from './ist/ist-application-ext/ist-study-team-team/ist-study-team-add-or-role/ist-study-team-add-or-role.component';
import { AttachmentClassificationComponent } from './common/attachment-classification/attachment-classification.component';
import { IstUserInstructionsModalComponent } from './ist/ist-my-applications/ist-user-instructions-modal/ist-user-instructions-modal.component';
import { EapUserInstructionsModalComponent } from './eap/eap-my-applications/eap-user-instructions-modal/eap-user-instructions-modal.component';
import { ConfigureControlsAddComponent } from './administration/screen-repository/configure-controls-modal/configure-controls-add/configure-controls-add.component';
import { SubmitInstructionsModalComponent } from 'src/app/common/submit/submit-instructions-modal/submit-instructions-modal.component';

import { DatePickerGlobalOptions } from '../app/constants/service.constants';
import { UploadGridDetails } from './common/upload-grid-details/upload-grid-details.component';
import { HeadService } from 'src/app/services/common/headservice';
import { SubmitComponent } from 'src/app/common/submit/submit.component';
import { DatePipe } from '@angular/common';
import { HistoryComponent } from './common/submit/history/history.component';
import { ExtendedFormControlsComponent } from './common/extended-form-controls/extended-form-controls.component';
import { IstDocumentTemplateDefinitionComponent } from './common/ist-document-template-definition/ist-document-template-definition.component';
import { ConfigureTemplateModalComponent } from './common/ist-document-template-definition/configure-template-modal/configure-template-modal.component';
import { ConfigureTemplateViewComponent } from './common/ist-document-template-definition/configure-template-modal/configure-template-view/configure-template-view.component';
import { ErrorPageComponent } from './common/error-page/error-page.component';
import { DocumentUploadComponent } from './common/document-upload/document-upload.component';
import { DynamicFormsComponent } from './common/dynamic-forms/dynamic-forms.component';
import { SupportUsersModalComponent } from './um/um-organization/support-users-modal/support-users-modal.component';
import { SupportUsersViewModalComponent } from './um/um-organization/support-users-modal/support-users-view-modal/support-users-view-modal.component';
import { HelpViewComponent } from './common/help-view/help-view.component';
import { ConfigurePolicyModalComponent } from './administration/policy-configurator/configure-policy-modal/configure-policy-modal.component';
import { SelectStatesModalComponent } from './administration/policy-configurator/select-states-modal/select-states-modal.component';
import { SelectScreensModalComponent } from './administration/policy-configurator/select-screens-modal/select-screens-modal.component';
import { ConfigureScreensModalComponent } from './administration/policy-configurator/configure-screens-modal/configure-screens-modal.component';
import { ProductNetworkLocationsComponent } from './administration/product-network-locations/product-network-locations.component';
import { ProductNetworkLocationsViewModalComponent } from './administration/product-network-locations/product-network-locations-view-modal/product-network-locations-view-modal.component';
import { AvailableNetworklocationsComponent } from './administration/available-networklocations/available-networklocations.component';
import { EapInstitutionalReviewBoardComponent } from './eap/eap-application-ext/eap-institutional-review-board/eap-institutional-review-board.component';
import { EapAllRequestsComponent } from './eap/eap-application-ext/eap-ist-all-requests/eap-all-requests.component';
import { EapStudyReportsComponent } from './eap/eap-application-ext/eap-study-reports/eap-study-reports.component';
import { EapAmendmentsComponent } from './eap/eap-application-ext/eap-amendments/eap-amendments.component';

import { GlobalHttpInterceptorService } from './global-http-Interceptor.service';
import { GlobalErrorHandlerService } from './global-error-handler.service';
import { LoaderComponent } from "./common/loader/loader.component";
import { HlookupsComponent } from './administration/hlookups/hlookups.component';
import { HlookupsModalEditComponent } from './administration/hlookups/hlookups-modal-edit/hlookups-modal-edit.component';
import { HlookupsAddMultipleComponent } from './administration/hlookups/hlookups-add-multiple/hlookups-add-multiple.component';
import { LoginLogComponent } from './common/loginlog/loginlog.component';
import { EapStudyTeamTeamViewModalComponent } from './eap/eap-application-ext/eap-study-team-team/eap-study-team-team-view-modal/eap-study-team-team-view-modal.component';
import { EapAmendmentsViewModalComponent } from './eap/eap-application-ext/eap-amendments/eap-amendments-view-modal/eap-amendments-view-modal.component';
import { EapStudyReportsViewModalComponent } from './eap/eap-application-ext/eap-study-reports/eap-study-reports-view-modal/eap-study-reports-view-modal.component';
import { EapAllRequestsViewModalComponent } from './eap/eap-application-ext/eap-ist-all-requests/eap-all-requests-view-modal/eap-all-requests-view-modal.component';
import { EapReturnRetrivalModalComponent } from './eap/eap-application-ext/eap-ist-all-requests/eap-return-retrival-modal/eap-return-retrival-modal.component';
import { EapStudyTeamOrganizationViewModalComponent } from './eap/eap-application-ext/eap-study-team-organization/eap-study-team-organization-view-modal/eap-study-team-organization-view-modal.component';
import { EapStudyTeamViewComponent } from './eap/eap-application-ext/eap-study-team-team/eap-study-team-view/eap-study-team-view.component';
import { GeneraloverviewComponent } from './common/generaloverview/generaloverview.component';
import { ListingComponent } from './common/listing/listing.component';
import { MatMenuModule } from "@angular/material/menu";
import { EmailComposeComponent } from './common/correspondence/email-compose/email-compose.component';
import { EmailDraftsComponent } from './common/correspondence/email-drafts/email-drafts.component';
import { EmailListComponent } from './common/correspondence/email-list/email-list.component';
import { EmailReadComponent } from './common/correspondence/email-read/email-read.component';
import { ExpandEmailComponent } from './common/correspondence/expand-email/expand-email.component';
import { CustomSingleDocComponent } from './common/document-summary/custom-single-doc/custom-single-doc.component';
import { FilePreviewComponent } from './common/document-summary/file-preview/file-preview.component';
import { ToBccComponent } from "./common/correspondence/to-bcc/to-bcc.component";
import { AdminConsoleComponent } from './administration/admin-console/admin-console.component';
import { SuperAdminAuditLogComponent } from './um/super-admin-audit-log/super-admin-audit-log.component';
import { CategoryAuditlogComponent } from './um/super-admin-audit-log/category-auditlog/category-auditlog.component';
import { AuditlogRevisionsComponent } from './um/super-admin-audit-log/auditlog-revisions/auditlog-revisions.component';
import { SuperadminExportComponent } from './um/super-admin-audit-log/superadmin-export/superadmin-export.component';
import { AdminAuditlogMainComponent } from './administration/admin-auditlog-main/admin-auditlog-main.component';
import { EditorModule, TINYMCE_SCRIPT_SRC } from "@tinymce/tinymce-angular";
import { AutoCompleteModule } from 'primeng/autocomplete';
import { HtmlViewerComponent } from './common/correspondence/html-viewer/html-viewer.component';
import { SafeHtmlPipe } from './common/correspondence/safe-html.pipe';
import { SuccessBanertemplateComponent } from './common/success-banertemplate/success-banertemplate.component';
import { SuperAdminEmailconfigComponent } from './um/super-admin-emailconfig/super-admin-emailconfig.component';
import { SaEmailconfigHistoryComponent } from './um/super-admin-emailconfig/sa-emailconfig-history/sa-emailconfig-history.component';
import { SaEmailconfigTestComponent } from './um/super-admin-emailconfig/sa-emailconfig-test/sa-emailconfig-test.component';
import { ErrorbannerComponent } from './common/errorbanner/errorbanner.component';
import { NgxPrintModule } from "ngx-print";
import { IEGAuditlogMainComponent } from './common/ieg-auditlog-main/ieg-auditlog-main.component';
import { AuditLogsComponent } from "./common/ieg-auditlog-main/audit-logs/audit-logs.component";
import { ActivityLogComponent } from "./common/ieg-auditlog-main/activity-log/activity-log.component";
import { PreviewAuditLogsComponent } from "./common/ieg-auditlog-main/audit-logs/preview-audit-logs/preview-audit-logs.component";
import { PreviewActivityLogComponent } from "./common/ieg-auditlog-main/activity-log/preview-activity-log/preview-activity-log.component";
import { AdminauditlogRevisionsComponent } from './administration/admin-auditlog-main/adminauditlog-revisions/adminauditlog-revisions.component';
import { AdmincategorySubcategoryAuditlogComponent } from './administration/admin-auditlog-main/admincategory-subcategory-auditlog/admincategory-subcategory-auditlog.component';
import { AdminauditExportComponent } from './administration/admin-auditlog-main/adminaudit-export/adminaudit-export.component';
import { AlertsAndNotificationsSummaryComponent } from './common/alerts-and-notifications-summary/alerts-and-notifications-summary.component';
import { AnModelViewComponent } from './common/alerts-and-notifications-summary/an-model-view/an-model-view.component';
import { LoginauditExportComponent } from './common/loginlog/loginaudit-export/loginaudit-export.component';
import { AuditLogsRevisionComponent } from './common/ieg-auditlog-main/audit-logs/audit-logs-revision/audit-logs-revision.component';
import { AuditLogsExportComponent } from './common/ieg-auditlog-main/audit-logs/audit-logs-export/audit-logs-export.component';
import { ExportActivityLogComponent } from './common/ieg-auditlog-main/activity-log/export-activity-log/export-activity-log.component';
import { SearchFilterPipe } from "./Pipes/search-filter.pipe";
import { EmailSetUpSummaryComponent } from './administration/email-set-up-summary/email-set-up-summary.component';
import { EmailAccountComponent } from './administration/email-set-up-summary/email-account/email-account.component';
import { EmailtestconnectionComponent } from './administration/email-set-up-summary/emailtestconnection/emailtestconnection.component';
import { EmailTemplatesSummaryComponent } from './administration/email-templates-summary/email-templates-summary.component';
import { EmailTemplatesModelViewComponent } from './administration/email-templates-summary/email-templates-model-view/email-templates-model-view.component';
import { KeyFilterModule } from "primeng/keyfilter";
import { SubmitValidationsComponent } from './common/submit-validations/submit-validations.component';
import { ChangeLogComponent } from './common/change-log/change-log.component';
import { IstActivitiesSeminarsSpeakersComponent } from './ist/ist-application-ext/ist-activities-seminars/ist-activities-seminars-speakers/ist-activities-seminars-speakers.component';
import { ConfirmationBoxComponent } from './common/confirmation-box/confirmation-box.component';
import { EapTypeReorderComponent } from './administration/eap-type/eap-type-reorder/eap-type-reorder.component';
import { NoSpecailCharsDirective } from "./Directives/no-specail-charsDirective";
import { OnlyNumbersDirective } from "./Directives/onlynumbersDirective";
import { OnlyCharctersDirective } from "./Directives/only-charctersDirective";
import { AppPreSetupModule, AppPreSetupService } from "./services/app-pre-setup.service";
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgbActiveModal, NgbDropdown, NgbModalModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { DropdownModule } from 'primeng/dropdown';
import { VersionHistoryComponent } from './administration/policy-configurator/version-history/version-history.component';
import { VersionDetailsComponent } from './administration/policy-configurator/version-details/version-details.component';
import { TooltipModule } from 'primeng/tooltip';
import { AnalyticshomeComponent } from "./analytics/analyticshome.component";
import { AdminLogiDashboardsComponent } from "./analytics/admin-logi-dashboards/admin-logi-dashboards.component";
import { LogiDashboardsViewModelComponent } from "./analytics/admin-logi-dashboards/logi-dashboards-view-model/logi-dashboards-view-model.component";
import { AnalyticDashboardsComponent } from './analytics/analytic-dashboards/analytic-dashboards.component';
import { AnalyticBuilderComponent } from './analytics/analytic-builder/analytic-builder.component';
import { AnalyticSchedulerComponent } from './analytics/analytic-scheduler/analytic-scheduler.component';
import { AddAnalyticsBuilderComponent } from './analytics/analytic-builder/add-analytics-builder/add-analytics-builder.component';
import { PublishAnalyticsComponent } from './analytics/analytic-builder/publish-analytics/publish-analytics.component';
import { EditAndDeleteOperationsRenderer } from "./common/client-grid/edit-and-delete-operations.component";
import { DocumentTypeAddComponent } from "./common/document-type-add/document-type-add.component";
import { UmRoleMapUsersViewModalComponent } from "./um/um-role/um-role-map-users-view-modal/um-role-map-users-view-modal.component";



@NgModule({
  declarations: [
    NoSpecailCharsDirective,
    OnlyNumbersDirective,
    OnlyCharctersDirective,
    SuperAdminAuditLogComponent,
    CategoryAuditlogComponent,
    AuditlogRevisionsComponent,
    SuperadminExportComponent,
    AdminAuditlogMainComponent,
    AuditLogsComponent,
    ActivityLogComponent,
    AppComponent,
    IstComponent,
    EapComponent,
    GrantsComponent,
    UmComponent,
    IstRegistrationsComponent,
    IstApplicationsComponent,
    IstMyApplicationsComponent,
    ClientGridComponent,
    DocumentTypeAddComponent,
    OperationsBarComponent,
    IstApplicationExtComponent,
    ExtHeaderComponent,
    HeaderComponent,
    IstGeneralInformationComponent,
    IstStudyTeamTeamComponent,
    MessageBoxComponent,
    AssignDialogComponent,
    UmDepartmentComponent,
    UmUserComponent,
    UmRoleComponent,
    UmOrganizationComponent,
    AdministrationComponent,
    PersonalizationComponent,
    ChangeThemeComponent,
    ChangePasswordComponent,
    ViewProfileComponent,
    LoginComponent,
    HomeComponent,
    UmUserViewModalComponent,
    UmDepartmentViewModalComponent,
    IstMilestonesComponent,
    IstStudyTeamOrganizationComponent,
    UmOrganizationViewModalComponent,
    UmRoleViewModalComponent,
    IstMilestonesViewModalComponent,
    IstAmendmentsComponent,
    IstAmendmentsViewModalComponent,
    IstSiteEvluationComponent,
    IstSiteEvaluationViewModalComponent,
    IstStudyReportsComponent,
    IstStudyReportsViewModalComponent,
    IstActivitiesSeminarsComponent,
    IstActivitiesSeminarsViewModalComponent,
    IstPublicationsComponent,
    IstPublicationsViewModalComponent,
    AttachmentsComponent,
    RfiComponent,
    NotesComponent,
    IstInstitutionalReviewBoardComponent,
    IstConceptProposalComponent,
    IstStudyTeamOrganizationViewModalComponent,
    IstStudyTeamTeamViewModalComponent,
    RouteComponent,
    SubmitComponent,
    NotesViewModalComponent,
    WithdrawComponent,
    AttachmentsViewModalComponent,
    RfiViewModalComponent,
    ConfirmOtpComponent,
    IstSiteEvaluationUpdateStatusComponent,
    DeleteBoxComponent,
    GrantsGeneralInformationComponent,
    GrantsGrantInformationComponent,
    IstRegistrationsViewModalComponent,
    UmOrganizationPasswordPolicyViewModalComponent,
    IstStudyTeamViewComponent,
    GrantsLetterOfIntentComponent,
    GrantsUserInstructionsComponent,
    GrantsDeliveryFormatComponent,
    GrantsAudiencesComponent,
    GrantsBudgetComponent,
    GrantsAuthorizedSigneeAndPayeeComponent,
    GrantsOutcomeAssessmentComponent,
    GrantsReconciliationComponent,
    GrantsDocumentUploadComponent,
    GrantsRegistrationsComponent,
    GrantsMyApplicationsComponent,
    GrantsApplicationsComponent,
    GrantsRegistrationsViewModalComponent,
    GrantsApplicationExtComponent,
    GrantsAuthorizedSigneeAndPayeeViewModalComponent,
    GrantsOutcomeAssessmentViewModalComponent,
    GrantsAudiencesViewModalComponent,
    EapApplicationsComponent,
    EapMyApplicationsComponent,
    EapApplicationExtComponent,
    EapProgramInfoComponent,
    EapStudyReportsComponent,
    EapAmendmentsComponent,
    EapStudyTeamTeamComponent,
    EapStudyTeamOrganizationComponent,
    EapInstitutionalReviewBoardComponent,
    EapAllRequestsComponent,
    CorrespondenceComponent,
    GrantsBudgetViewModalComponent,
    GrantsBudgetAllocateComponent,
    GrantsBudgetViewBudgetRequestComponent,
    GrantsBudgetRecordExpenditureComponent,
    LookupsComponent,
    ProductComponent,
    ProgramComponent,
    CCodeComponent,
    NotificationStoreComponent,
    LdapConfigurationComponent,
    SamlSsoConfigurationComponent,
    ForgotPasswordComponent,
    EapTypeComponent,
    LookupsModalEditComponent,
    LookupsAddMultipleComponent,
    EapTypeViewComponent,
    ProductViewModalComponent,
    AddProductApprovalComponent,
    AvailableProductsComponent,
    ProgramViewModalComponent,
    SetFormatComponent,
    ToBccComponent,
    UmUserMapUserViewModalComponent,
    GrantsRegistrationsComplianceComponent,
    RequestTypeModalComponent,
    LetterOfIntentModalComponent,
    UserInstructionModalComponent,
    RfiAddModalComponent,
    EditOthersRenderer,
    DeleteOperationsRenderer,
    EditAndDeleteOperationsRenderer,
    MyFilterPipe,
    NoAddBtnPipe,
    TextareaAddonComponent,
    ComplainceStatementComponent,
    IstAllRequestsComponent,
    AllRequestsViewModalComponent,
    LookupsSortOrderComponent,
    ReturnRetrivalModalComponent,
    FundRequestModalComponent,
    FundReturnRetrivalModalComponent,
    InstructionsComponent,
    InstructionsModalComponent,
    FaqComponent,
    FaqModalComponent,
    FaqViewComponent,
    DocumentTemplateComponent,
    PolicyConfiguratorComponent,
    ScreenRepositoryComponent,
    ScreenRepositoryModalComponent,
    ConfigureControlsModalComponent,
    GrantsDocumentUploadSponsorshipComponent,
    GrantsGeneralInformationCharitableComponent,
    GrantsGeneralInformationSponsorshipComponent,
    RfpGrantsComponent,
    FileUploadComponent,
    IstStudyTeamAddOrRoleComponent,
    AttachmentClassificationComponent,
    IstUserInstructionsModalComponent,
    EapUserInstructionsModalComponent,
    ConfigureControlsAddComponent,
    UploadGridDetails,
    HistoryComponent,
    ExtendedFormControlsComponent,
    IstDocumentTemplateDefinitionComponent,
    ConfigureTemplateModalComponent,
    ConfigureTemplateViewComponent,
    ErrorPageComponent,
    DocumentUploadComponent,
    DynamicFormsComponent,
    SubmitInstructionsModalComponent,
    SupportUsersModalComponent,
    SupportUsersViewModalComponent,
    HelpViewComponent,
    ConfigurePolicyModalComponent,
    SelectStatesModalComponent,
    SelectScreensModalComponent,
    ConfigureScreensModalComponent,
    ProductNetworkLocationsComponent,
    ProductNetworkLocationsViewModalComponent,
    AvailableNetworklocationsComponent,
    LoaderComponent,
    HlookupsComponent,
    HlookupsModalEditComponent,
    HlookupsAddMultipleComponent,
    LoginLogComponent,
    EapStudyTeamTeamViewModalComponent,
    EapStudyTeamViewComponent,
    EapAmendmentsComponent,
    EapAmendmentsViewModalComponent,
    EapStudyReportsComponent,
    EapStudyReportsViewModalComponent,
    EapAllRequestsViewModalComponent,
    EapReturnRetrivalModalComponent,
    EapStudyTeamOrganizationViewModalComponent,
    GeneraloverviewComponent,
    ListingComponent,
    AdminConsoleComponent,
    EmailComposeComponent,
    EmailDraftsComponent,
    EmailListComponent,
    EmailReadComponent,
    ExpandEmailComponent,
    CustomSingleDocComponent,
    FilePreviewComponent,
    HtmlViewerComponent,
    SafeHtmlPipe,
    PreviewAuditLogsComponent,
    PreviewActivityLogComponent,
    SuccessBanertemplateComponent,
    SuperAdminEmailconfigComponent,
    SaEmailconfigHistoryComponent,
    SaEmailconfigTestComponent,
    ErrorbannerComponent,
    IEGAuditlogMainComponent,
    AdminauditlogRevisionsComponent,
    AdmincategorySubcategoryAuditlogComponent,
    AdminauditExportComponent,
    AlertsAndNotificationsSummaryComponent,
    AnModelViewComponent,
    LoginauditExportComponent,
    AuditLogsRevisionComponent,
    AuditLogsExportComponent,
    ExportActivityLogComponent,
    SearchFilterPipe,
    EmailSetUpSummaryComponent,
    EmailAccountComponent,
    EmailtestconnectionComponent,
    EmailTemplatesSummaryComponent,
    EmailTemplatesModelViewComponent,
    SubmitValidationsComponent,
    ChangeLogComponent,
    IstActivitiesSeminarsSpeakersComponent,
    ConfirmationBoxComponent,
    EapTypeReorderComponent,
    VersionHistoryComponent,
    VersionDetailsComponent,
    LogiDashboardsViewModelComponent,
    AdminLogiDashboardsComponent,
    AnalyticshomeComponent,
    AnalyticDashboardsComponent,
    AnalyticBuilderComponent,
    AnalyticSchedulerComponent,
    AddAnalyticsBuilderComponent,
    PublishAnalyticsComponent,
    UmRoleMapUsersViewModalComponent 
  ],
  imports: [
    TooltipModule,
    FormsModule,
    CalendarModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AgGridModule,
    NgxSortableModule,
    MatMenuModule,
    EditorModule,
    AutoCompleteModule,
    NgxPrintModule,
    KeyFilterModule,
    DropdownModule,
    NgbModalModule,
    NgbModule,
    MultiSelectModule
  ],
  providers: [
    AppPreSetupService,
    AppPreSetupModule.init(),
    { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpInterceptorService, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
    HeadService,
    DatePipe,
    LoaderComponent,
    NgbActiveModal,
    NgbDropdown
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }

